import React , {useState, useEffect} from 'react';
import CommonService from "../services/CommonService";
import PropTypes from 'prop-types';
const Base64ImageRender = (props) => {
    const [imageData, setImageData] = useState('');
   
    
    const imageCall = async (passeddata) => {
        let resp = await CommonService.downloadBlob(passeddata);
        setImageData(resp);
        return resp;

    }
    

    useEffect(() => {

        imageCall(props?.url)
    }, []);

    return (
        <div>
            <img
                src={imageData}
                // style={{ width: "30%"}}
                style={{height:'80px', width:'80px', borderRadius:'50%',padding:'10px'}}
            />
        </div>
    )

}

export default Base64ImageRender;
Base64ImageRender.propTypes = {
    url: PropTypes.string

}
